const messages = {
  title: 'Gateway timeout-feil',
  description: 'Vi beklager ulempene. Det ser ut til at serveren vår ikke mottok et rettidig svar.',
  backHomeButton: 'Tilbake til dashbord'
}

export default {
  messages
}
